import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "dining-table-for-4",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "dining-table-for-4",
    description: "bathroom-sink",
    image: require("./dining-table-for-4.svg"),
    svgIcon: require("./dining-table-for-4.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 10,
      max: 500,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 10,
      max: 500,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-47, 40) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M15.66,14.45a7.86,7.86,0,0,1-.89-.11,1.79,1.79,0,0,1-1.54-1.76A1.78,1.78,0,0,1,14.84,11a4.91,4.91,0,0,1,.86-.08H39.63a4.7,4.7,0,0,1,.92.09,1.84,1.84,0,0,1,1.55,1.7,1.88,1.88,0,0,1-1.58,1.68c-.32.06-.65.07-.9.1l.79,3.33h19.1l.76-3.31a8.85,8.85,0,0,1-1.21-.24,1.63,1.63,0,0,1-1.22-1.72A1.81,1.81,0,0,1,59.32,11a5.92,5.92,0,0,1,1.19-.1h23.6a4.75,4.75,0,0,1,1.36.19,1.63,1.63,0,0,1,1.21,1.6,1.72,1.72,0,0,1-1.25,1.57c-.42.12-.85.16-1.29.24a13.46,13.46,0,0,1,.55,1.58,16.93,16.93,0,0,1,.2,1.75h12.8c1,0,1.13.14,1.13,1.14V76.53c0,1-.17,1.14-1.2,1.14H85l-.74,3.63a7.49,7.49,0,0,1,1,.15,1.71,1.71,0,0,1,1.39,1.86,1.92,1.92,0,0,1-1.8,1.52h-.46q-12.14,0-24.27,0a3.66,3.66,0,0,1-1.44-.34,1.44,1.44,0,0,1-.86-1.54,1.54,1.54,0,0,1,1.08-1.35,9.7,9.7,0,0,1,1.33-.32l-.74-3.56H40.41l-.75,3.58a10.44,10.44,0,0,1,1,.17,1.74,1.74,0,0,1,1.39,1.8,2,2,0,0,1-1.78,1.57H15.51a3.09,3.09,0,0,1-1.21-.22A1.57,1.57,0,0,1,13.24,83a1.63,1.63,0,0,1,1.21-1.47,5.64,5.64,0,0,1,1.19-.23l-.74-3.61H.88c-1,0-1.12-.15-1.12-1.08V18.89c0-.95.13-1.07,1.12-1.07,4.47,0,9,0,13.42,0,.56,0,.78-.09.82-.72A19.92,19.92,0,0,1,15.66,14.45ZM.73,76.85H97.79V18.66H.73Zm59.93.84a5.06,5.06,0,0,0,.65,3.17.92.92,0,0,0,.9.48c2.32,0,4.63,0,6.94,0H82.31a1,1,0,0,0,.69-.2,4.58,4.58,0,0,0,.86-3.43Zm-21.42,0H16.07a4.47,4.47,0,0,0,.7,3.2,1.05,1.05,0,0,0,.73.38q10.14,0,20.27,0a1.11,1.11,0,0,0,.78-.42A4.52,4.52,0,0,0,39.24,77.73ZM83.88,17.78a4.41,4.41,0,0,0-.7-2.88,1.22,1.22,0,0,0-.82-.46c-.84-.06-1.68,0-2.51,0-5.84,0-11.67,0-17.51,0a1.23,1.23,0,0,0-.87.27,4.26,4.26,0,0,0-.81,3.08Zm-44.65,0A4.65,4.65,0,0,0,38.66,15a1.06,1.06,0,0,0-1.06-.57c-3.7,0-7.4,0-11.1,0-2.95,0-5.9,0-8.85,0a1.08,1.08,0,0,0-.76.23,4,4,0,0,0-.81,3.13Zm33.06-6.15H60.47a2.27,2.27,0,0,0-1.08.2,1.08,1.08,0,0,0-.56.78,1.24,1.24,0,0,0,.58.83,2.43,2.43,0,0,0,1.09.18H84a4,4,0,0,0,.85-.07c.47-.11.89-.39.82-.87a1.54,1.54,0,0,0-.68-.9,2.09,2.09,0,0,0-1-.15Zm-44.67,2H39.39a2.31,2.31,0,0,0,1-.14c.29-.16.63-.51.63-.78a1.37,1.37,0,0,0-.58-.9,1.49,1.49,0,0,0-.88-.17H15.78a1.59,1.59,0,0,0-.83.12c-.3.22-.7.58-.7.88s.38.69.7.87a2.16,2.16,0,0,0,1,.12ZM72.23,84.07H84.12a2.9,2.9,0,0,0,.66,0c.52-.1.92-.38.94-.93s-.37-.81-.85-.93a2.89,2.89,0,0,0-.72-.07H60.37c-1,0-1.61.4-1.59,1s.6,1,1.55,1Zm-44.54,0H39.45a5.72,5.72,0,0,0,.72,0,1,1,0,0,0,.93-.88.88.88,0,0,0-.72-1,2.94,2.94,0,0,0-.84-.11H15.82a2.88,2.88,0,0,0-.72.06c-.53.13-1,.4-.89,1s.51.82,1.06.88c.2,0,.4,0,.6,0Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M.73,76.85V18.66H97.79V76.85Zm19.1-9.2a5.15,5.15,0,0,0,1.6,3.73,9,9,0,0,0,11.63.76,5.59,5.59,0,0,0,.53-8.81,9.07,9.07,0,0,0-10.83-.8A5.85,5.85,0,0,0,19.83,67.65Zm52.8-6.53a8.75,8.75,0,0,0-6,2.2,5.53,5.53,0,0,0-.36,8A9,9,0,0,0,78.09,72,5.57,5.57,0,0,0,78,63,8.62,8.62,0,0,0,72.63,61.12ZM26.7,34.63c3.11,0,4.86-.59,6.42-1.81A5.53,5.53,0,0,0,34.39,25c-2.84-3.72-8.87-4.24-12.48-1.08a5.55,5.55,0,0,0,.19,8.84A8.13,8.13,0,0,0,26.7,34.63ZM72.36,21.87a8.31,8.31,0,0,0-4.65,1.34c-3.65,2.33-4,6.64-.84,9.44a9.09,9.09,0,0,0,11.32,0,5.55,5.55,0,0,0-.15-9A8.47,8.47,0,0,0,72.36,21.87ZM41,62.78a3.47,3.47,0,0,0,.51,0,2.72,2.72,0,0,0,2.33-2.16A2.4,2.4,0,0,0,42,58.15a3.41,3.41,0,0,0-2.81.19,2.15,2.15,0,0,0-.76,3.47A3.12,3.12,0,0,0,41,62.78Zm-.13-25a2.81,2.81,0,0,0,3-2.31c.07-1.3-1-2.35-2.65-2.53l-.26,0a2.71,2.71,0,0,0-3,2.64A2.8,2.8,0,0,0,40.84,37.82ZM85.57,57.94a5.5,5.5,0,0,0-.93.17,2.5,2.5,0,0,0-1.81,1.8,2,2,0,0,0,.77,2.14,3.5,3.5,0,0,0,3.94.25,2.16,2.16,0,0,0,.74-3.19A3.21,3.21,0,0,0,85.57,57.94Zm-.07-25a7.37,7.37,0,0,0-1.38.43,2.16,2.16,0,0,0-.55,3.69,3.49,3.49,0,0,0,3.72.4,2.2,2.2,0,0,0,1.2-3C87.93,33.4,86.93,33,85.5,32.93ZM18.28,28c0-1.43,0-2.86,0-4.28,0-.17-.17-.33-.26-.49-.08.17-.23.34-.23.5,0,2.85,0,5.71,0,8.56,0,.16.17.32.25.48.09-.16.24-.33.24-.5C18.29,30.83,18.28,29.4,18.28,28Zm64,0c0-1.4,0-2.81,0-4.21,0-.19-.16-.37-.25-.55-.08.17-.23.34-.23.51q0,4.28,0,8.55c0,.16.17.32.25.48.08-.17.23-.33.24-.5C82.3,30.82,82.3,29.4,82.3,28ZM18,63l-.22.15c0,3,0,6,0,9,0,.13.17.26.26.4.08-.13.22-.26.22-.39q0-4.36,0-8.75C18.27,63.24,18.09,63.1,18,63Zm64,0-.22.15c0,3,0,6,0,9,0,.14.17.27.26.41.08-.13.23-.26.23-.38q0-4.38,0-8.76C82.28,63.24,82.11,63.1,82,63Zm1.26,8.57.22.1a1.33,1.33,0,0,0,.22-.49q0-3.4,0-6.79c0-.15-.16-.3-.25-.45l-.19.09Zm.18-47.39-.16.09v7.52l.17.07c.09-.14.24-.28.25-.43q0-3.41,0-6.81C83.7,24.43,83.54,24.29,83.45,24.14ZM37.37,28c0-1.43,0-2.86,0-4.28a1.38,1.38,0,0,0-.19-.48c-.08.16-.23.32-.23.49q0,4.27,0,8.56c0,.16.13.32.19.48.08-.17.24-.33.24-.49C37.38,30.83,37.37,29.4,37.37,28Zm25.32-.07c0,1.45,0,2.9,0,4.35,0,.16.16.32.25.49a1.57,1.57,0,0,0,.18-.48c0-2.86,0-5.71,0-8.57,0-.16-.15-.32-.24-.48-.06.16-.19.32-.19.48C62.68,25.1,62.69,26.51,62.69,27.91ZM36.93,67.77c0,1.41,0,2.81,0,4.21a1.56,1.56,0,0,0,.2.53c.08-.17.22-.33.22-.5,0-2.83,0-5.67,0-8.5,0-.16-.15-.32-.23-.49a2,2,0,0,0-.2.54C36.92,65,36.93,66.37,36.93,67.77Zm26.21,0c0-1.4,0-2.81,0-4.21A1.66,1.66,0,0,0,62.9,63a1.69,1.69,0,0,0-.2.54c0,2.81,0,5.62,0,8.43a1.63,1.63,0,0,0,.21.52c.08-.17.22-.33.22-.5C63.15,70.6,63.14,69.2,63.14,67.79Zm-24.34,0c0-1.11,0-2.21,0-3.31a1.64,1.64,0,0,0-.2-.53c-.09.17-.24.33-.24.5,0,2.21,0,4.41,0,6.62,0,.16.16.33.25.49a1.78,1.78,0,0,0,.19-.53C38.81,70,38.8,68.88,38.8,67.8Zm0-39.86c0-1.08,0-2.16,0-3.24,0-.17-.15-.34-.23-.5-.07.15-.21.31-.21.46,0,2.23,0,4.45,0,6.68,0,.14.16.29.24.43a1.32,1.32,0,0,0,.2-.46C38.81,30.18,38.8,29.06,38.8,27.94Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M60.66,77.69h23.2A4.58,4.58,0,0,1,83,81.12a1,1,0,0,1-.69.2H69.15c-2.31,0-4.62,0-6.94,0a.92.92,0,0,1-.9-.48A5.06,5.06,0,0,1,60.66,77.69Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M39.24,77.73a4.52,4.52,0,0,1-.69,3.16,1.11,1.11,0,0,1-.78.42q-10.14,0-20.27,0a1.05,1.05,0,0,1-.73-.38,4.47,4.47,0,0,1-.7-3.2Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M83.88,17.78H60.66a4.26,4.26,0,0,1,.81-3.08,1.23,1.23,0,0,1,.87-.27c5.84,0,11.67,0,17.51,0,.83,0,1.67,0,2.51,0a1.22,1.22,0,0,1,.82.46A4.41,4.41,0,0,1,83.88,17.78Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M39.23,17.79H16.08a4,4,0,0,1,.81-3.13,1.08,1.08,0,0,1,.76-.23c3,0,5.9,0,8.85,0,3.7,0,7.4,0,11.1,0a1.06,1.06,0,0,1,1.06.57A4.65,4.65,0,0,1,39.23,17.79Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M72.29,11.64H84a2.09,2.09,0,0,1,1,.15,1.54,1.54,0,0,1,.68.9c.07.48-.35.76-.82.87a4,4,0,0,1-.85.07H60.5a2.43,2.43,0,0,1-1.09-.18,1.24,1.24,0,0,1-.58-.83,1.08,1.08,0,0,1,.56-.78,2.27,2.27,0,0,1,1.08-.2Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M27.62,13.64H16a2.16,2.16,0,0,1-1-.12c-.32-.18-.7-.57-.7-.87s.4-.66.7-.88a1.59,1.59,0,0,1,.83-.12H39.59a1.49,1.49,0,0,1,.88.17,1.37,1.37,0,0,1,.58.9c0,.27-.34.62-.63.78a2.31,2.31,0,0,1-1,.14Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M72.23,84.07H60.33c-.95,0-1.53-.36-1.55-1s.61-1,1.59-1H84.15a2.89,2.89,0,0,1,.72.07c.48.12.87.4.85.93s-.42.83-.94.93a2.9,2.9,0,0,1-.66,0Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M27.69,84.07H15.87c-.2,0-.4,0-.6,0-.55-.06-1-.3-1.06-.88s.36-.88.89-1a2.88,2.88,0,0,1,.72-.06H39.54a2.94,2.94,0,0,1,.84.11.88.88,0,0,1,.72,1,1,1,0,0,1-.93.88,5.72,5.72,0,0,1-.72,0Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M19.83,67.65a5.85,5.85,0,0,1,2.93-5.12,9.07,9.07,0,0,1,10.83.8,5.59,5.59,0,0,1-.53,8.81,9,9,0,0,1-11.63-.76A5.15,5.15,0,0,1,19.83,67.65Zm7.84-6.12a8.25,8.25,0,0,0-5.2,1.73,5.22,5.22,0,0,0-.25,8.28,8.5,8.5,0,0,0,10.68.16,5.19,5.19,0,0,0,.36-8.06A8,8,0,0,0,27.67,61.53Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M72.63,61.12A8.62,8.62,0,0,1,78,63a5.57,5.57,0,0,1,0,9.06,9,9,0,0,1-11.83-.69,5.53,5.53,0,0,1,.36-8A8.75,8.75,0,0,1,72.63,61.12Zm-7.42,6.53a4.74,4.74,0,0,0,1,2.91c2.58,3.4,8,4,11.56,1.15a5.15,5.15,0,0,0,.42-8,8.62,8.62,0,0,0-9.75-1.13C66.55,63.66,65.21,65.15,65.21,67.65Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M26.7,34.63a8.13,8.13,0,0,1-4.6-1.88,5.55,5.55,0,0,1-.19-8.84c3.61-3.16,9.64-2.64,12.48,1.08a5.53,5.53,0,0,1-1.27,7.83C31.56,34,29.81,34.62,26.7,34.63Zm1.38-.4a7.88,7.88,0,0,0,4.84-1.81,5.18,5.18,0,0,0,.55-7.83A8.44,8.44,0,0,0,22,24.4a5.14,5.14,0,0,0,.16,7.84A8.39,8.39,0,0,0,28.08,34.23Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M72.36,21.87A8.47,8.47,0,0,1,78,23.7a5.55,5.55,0,0,1,.15,9,9.09,9.09,0,0,1-11.32,0c-3.2-2.8-2.81-7.11.84-9.44A8.31,8.31,0,0,1,72.36,21.87Zm.26.39A8.18,8.18,0,0,0,67.3,24a5.2,5.2,0,0,0-.74,7.69c2.93,3.33,9,3.33,12,0a5,5,0,0,0,.31-6.6A7.62,7.62,0,0,0,72.62,22.26Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M41,62.78a3.12,3.12,0,0,1-2.51-1,2.15,2.15,0,0,1,.76-3.47A3.41,3.41,0,0,1,42,58.15a2.4,2.4,0,0,1,1.78,2.44,2.72,2.72,0,0,1-2.33,2.16A3.47,3.47,0,0,1,41,62.78Zm-.19-.34a6.26,6.26,0,0,0,1.08-.22,2,2,0,0,0,1.45-1.75A1.88,1.88,0,0,0,42,58.58a2.62,2.62,0,0,0-2.9.37,2.3,2.3,0,0,0-.7,1.38C38.28,61.47,39.37,62.36,40.78,62.44Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M40.84,37.82a2.8,2.8,0,0,1-3-2.23,2.71,2.71,0,0,1,3-2.64l.26,0c1.62.18,2.72,1.23,2.65,2.53A2.81,2.81,0,0,1,40.84,37.82Zm0-.4a2.34,2.34,0,0,0,2.5-1.83,2.23,2.23,0,0,0-2.43-2.25,2.37,2.37,0,0,0-2.49,1.78A2.21,2.21,0,0,0,40.81,37.42Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M85.57,57.94a3.21,3.21,0,0,1,2.71,1.17,2.16,2.16,0,0,1-.74,3.19,3.5,3.5,0,0,1-3.94-.25,2,2,0,0,1-.77-2.14,2.5,2.5,0,0,1,1.81-1.8A5.5,5.5,0,0,1,85.57,57.94Zm.11,4.46,0,.08a9.12,9.12,0,0,0,1.38-.4,1.85,1.85,0,0,0,1.15-1.76,1.72,1.72,0,0,0-1.18-1.65,4.72,4.72,0,0,0-2-.2,2,2,0,0,0-1.77,2,2.2,2.2,0,0,0,1.91,1.93A4.75,4.75,0,0,0,85.68,62.4Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M85.5,32.93c1.43.08,2.43.47,3,1.55a2.2,2.2,0,0,1-1.2,3,3.49,3.49,0,0,1-3.72-.4,2.16,2.16,0,0,1,.55-3.69A7.37,7.37,0,0,1,85.5,32.93Zm.08,4.49a2.48,2.48,0,0,0,2.63-1.74,2,2,0,0,0-1.51-2.15,4.32,4.32,0,0,0-2,0,1.92,1.92,0,0,0-1.47,1.92A2.19,2.19,0,0,0,85,37.32C85.2,37.38,85.47,37.4,85.58,37.42Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M18.28,28c0,1.42,0,2.85,0,4.27,0,.17-.15.34-.24.5-.08-.16-.24-.32-.25-.48,0-2.85,0-5.71,0-8.56,0-.16.15-.33.23-.5.09.16.26.32.26.49C18.29,25.12,18.28,26.55,18.28,28Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M82.3,28c0,1.43,0,2.85,0,4.28,0,.17-.16.33-.24.5-.08-.16-.25-.32-.25-.48q0-4.28,0-8.55c0-.17.15-.34.23-.51.09.18.25.36.25.55C82.31,25.16,82.3,26.57,82.3,28Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M18,63c.1.14.28.28.28.42q0,4.38,0,8.75c0,.13-.14.26-.22.39-.09-.14-.26-.27-.26-.4,0-3,0-6,0-9Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M82,63c.1.14.27.28.27.42q0,4.38,0,8.76c0,.12-.15.25-.23.38-.09-.14-.26-.27-.26-.41,0-3,0-6,0-9Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M83.27,71.53V64l.19-.09c.09.15.25.3.25.45q0,3.39,0,6.79a1.33,1.33,0,0,1-.22.49Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M83.45,24.14c.09.15.25.29.26.44q0,3.41,0,6.81c0,.15-.16.29-.25.43l-.17-.07V24.23Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M37.37,28c0,1.42,0,2.85,0,4.28,0,.16-.16.32-.24.49-.06-.16-.19-.32-.19-.48q0-4.29,0-8.56c0-.17.15-.33.23-.49a1.38,1.38,0,0,1,.19.48C37.38,25.12,37.37,26.55,37.37,28Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M62.69,27.91c0-1.4,0-2.81,0-4.21,0-.16.13-.32.19-.48.09.16.24.32.24.48,0,2.86,0,5.71,0,8.57a1.57,1.57,0,0,1-.18.48c-.09-.17-.25-.33-.25-.49C62.68,30.81,62.69,29.36,62.69,27.91Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M36.93,67.77c0-1.4,0-2.81,0-4.21a2,2,0,0,1,.2-.54c.08.17.23.33.23.49,0,2.83,0,5.67,0,8.5,0,.17-.14.33-.22.5a1.56,1.56,0,0,1-.2-.53C36.92,70.58,36.93,69.18,36.93,67.77Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M63.14,67.79c0,1.41,0,2.81,0,4.22,0,.17-.14.33-.22.5A1.63,1.63,0,0,1,62.7,72c0-2.81,0-5.62,0-8.43a1.69,1.69,0,0,1,.2-.54,1.66,1.66,0,0,1,.23.56C63.15,65,63.14,66.39,63.14,67.79Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M38.8,67.8c0,1.08,0,2.16,0,3.24a1.78,1.78,0,0,1-.19.53c-.09-.16-.25-.33-.25-.49,0-2.21,0-4.41,0-6.62,0-.17.15-.33.24-.5a1.64,1.64,0,0,1,.2.53C38.81,65.59,38.8,66.69,38.8,67.8Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M38.8,27.94c0,1.12,0,2.24,0,3.37a1.32,1.32,0,0,1-.2.46c-.08-.14-.24-.29-.24-.43,0-2.23,0-4.45,0-6.68,0-.15.14-.31.21-.46.08.16.23.33.23.5C38.81,25.78,38.8,26.86,38.8,27.94Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M27.67,61.53a8,8,0,0,1,5.59,2.11,5.19,5.19,0,0,1-.36,8.06,8.5,8.5,0,0,1-10.68-.16,5.22,5.22,0,0,1,.25-8.28A8.25,8.25,0,0,1,27.67,61.53Zm0,11.12a4.72,4.72,0,0,0,.43-.27c1.84-1.5,3.68-3,5.53-4.5.47-.37.31-.6-.06-.9q-2.67-2.16-5.33-4.35a.71.71,0,0,0-1.08,0c-1.77,1.47-3.56,2.9-5.33,4.35-.56.46-.56.55,0,1l5.34,4.35C27.35,72.45,27.52,72.54,27.68,72.65Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M65.21,67.65c0-2.5,1.34-4,3.22-5.11a8.62,8.62,0,0,1,9.75,1.13,5.15,5.15,0,0,1-.42,8c-3.52,2.8-9,2.25-11.56-1.15A4.74,4.74,0,0,1,65.21,67.65Zm7.39,5,.44-.31c1.84-1.5,3.68-3,5.54-4.5.41-.33.3-.53,0-.8q-2.75-2.22-5.48-4.47a.64.64,0,0,0-.93,0L66.56,67.1c-.33.26-.32.46,0,.72l5.58,4.54A4.61,4.61,0,0,0,72.6,72.65Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M28.08,34.23a8.39,8.39,0,0,1-5.9-2A5.14,5.14,0,0,1,22,24.4a8.44,8.44,0,0,1,11.45.19,5.18,5.18,0,0,1-.55,7.83A7.88,7.88,0,0,1,28.08,34.23Zm6-6.06a2.33,2.33,0,0,1-.42-.24c-1.87-1.52-3.73-3-5.58-4.56a.6.6,0,0,0-.88,0L21.7,27.9c-.34.28-.33.51,0,.78,1.87,1.52,3.72,3.05,5.6,4.54a.78.78,0,0,0,.74,0c1.91-1.52,3.8-3.08,5.69-4.63A4.33,4.33,0,0,0,34.11,28.17Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M72.62,22.26a7.62,7.62,0,0,1,6.21,2.88,5,5,0,0,1-.31,6.6c-3,3.32-9,3.32-12,0A5.2,5.2,0,0,1,67.3,24,8.18,8.18,0,0,1,72.62,22.26Zm-6.37,6.06a3,3,0,0,0,.34.36c1.84,1.51,3.7,3,5.53,4.52.37.31.64.23,1-.05,1.8-1.49,3.6-3,5.43-4.43.42-.33.4-.52,0-.84q-2.76-2.22-5.49-4.47a.62.62,0,0,0-.92,0c-1.84,1.52-3.7,3-5.54,4.52A2.3,2.3,0,0,0,66.25,28.32Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M40.78,62.44c-1.41-.08-2.5-1-2.38-2.11A2.3,2.3,0,0,1,39.1,59a2.62,2.62,0,0,1,2.9-.37,1.88,1.88,0,0,1,1.31,1.89,2,2,0,0,1-1.45,1.75A6.26,6.26,0,0,1,40.78,62.44Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M40.81,37.42a2.21,2.21,0,0,1-2.42-2.3,2.37,2.37,0,0,1,2.49-1.78,2.23,2.23,0,0,1,2.43,2.25A2.34,2.34,0,0,1,40.81,37.42Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M85.68,62.4a4.75,4.75,0,0,1-.53,0,2.2,2.2,0,0,1-1.91-1.93,2,2,0,0,1,1.77-2,4.72,4.72,0,0,1,2,.2,1.72,1.72,0,0,1,1.18,1.65,1.85,1.85,0,0,1-1.15,1.76,9.12,9.12,0,0,1-1.38.4Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M85.58,37.42c-.11,0-.38,0-.63-.1a2.19,2.19,0,0,1-1.71-1.84,1.92,1.92,0,0,1,1.47-1.92,4.32,4.32,0,0,1,2,0,2,2,0,0,1,1.51,2.15A2.48,2.48,0,0,1,85.58,37.42Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M27.68,72.65c-.16-.11-.33-.2-.48-.32L21.86,68c-.58-.47-.58-.56,0-1,1.77-1.45,3.56-2.88,5.33-4.35a.71.71,0,0,1,1.08,0q2.66,2.19,5.33,4.35c.37.3.53.53.06.9-1.85,1.49-3.69,3-5.53,4.5A4.72,4.72,0,0,1,27.68,72.65Zm5.79-5.2-5.78-4.7-5.77,4.71,5.77,4.71Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M72.6,72.65a4.61,4.61,0,0,1-.46-.29l-5.58-4.54c-.32-.26-.33-.46,0-.72l5.57-4.55a.64.64,0,0,1,.93,0q2.73,2.25,5.48,4.47c.34.27.45.47,0,.8-1.86,1.49-3.7,3-5.54,4.5Zm5.76-5.19-5.78-4.72c-1.93,1.59-3.84,3.14-5.77,4.72l5.77,4.71Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M34.11,28.17a4.33,4.33,0,0,1-.38.46C31.84,30.18,30,31.74,28,33.26a.78.78,0,0,1-.74,0c-1.88-1.49-3.73-3-5.6-4.54-.33-.27-.34-.5,0-.78l5.53-4.5a.6.6,0,0,1,.88,0c1.85,1.53,3.71,3,5.58,4.56A2.33,2.33,0,0,0,34.11,28.17Zm-.64.13-5.78-4.72L21.92,28.3,27.69,33Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              d="M66.25,28.32a2.3,2.3,0,0,1,.34-.4c1.84-1.51,3.7-3,5.54-4.52a.62.62,0,0,1,.92,0q2.73,2.25,5.49,4.47c.39.32.41.51,0,.84-1.83,1.46-3.63,2.94-5.43,4.43-.34.28-.61.36-1,.05-1.83-1.51-3.69-3-5.53-4.52A3,3,0,0,1,66.25,28.32Zm.56,0L72.59,33l5.77-4.71-5.78-4.72Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M33.47,67.45l-5.78,4.72-5.77-4.71,5.77-4.71Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M78.36,67.46l-5.78,4.71-5.77-4.71c1.93-1.58,3.84-3.13,5.77-4.72Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M33.47,28.3,27.69,33,21.92,28.3l5.77-4.72Z"
              transform="translate(0.24 -10.88)"
            />
            <path
              class="cls-1"
              d="M66.81,28.3l5.77-4.72,5.78,4.72L72.59,33Z"
              transform="translate(0.24 -10.88)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
